<template>
	<div>
		<div>
			<Button type="primary" icon="ios-search" @click="searchByConditionsView">搜索</Button>
			<Button type="primary" icon="md-cloud-upload" style="margin-left: 20px;"
				@click="clickImport">导入Excel</Button>
			<Button type="primary" style="margin-left: 20px;" @click="downTemplate">下载模版</Button>
			<Button type="primary" style="margin-left: 20px;" @click="clickBatchDelete">批量删除</Button>
		</div>

		<Table ref="table" size="large" border stripe :loading="loading" :columns="columns1" :data="data1"
			@on-selection-change="onSelectionChange" style="margin: 20px 0;">
			<template slot-scope="{ row, index }" slot="deparams">
				<div style="display: flex;justify-content: space-around;">
					<Button v-if="row.baseNum==null||row.baseNum==''" type="primary" @click="clickBindBase(row)"
						style="padding: 5px 5px 6px;">绑定基表</Button>
					<Button v-else type="primary" @click="clickUnbindBase(row)"
						style="padding: 5px 5px 6px;">解绑基表</Button>
					<Button type="primary" @click="clickDelete(row)" style="padding: 5px 5px 6px;">删除</Button>
				</div>
			</template>
		</Table>
		<Page :current="currentPage" :total="totalRows" :page-size="pageSize" :page-size-opts="[5, 10, 20, 30, 40]"
			show-sizer show-total @on-change="changePage" @on-page-size-change="changePageSize" />

		<Upload ref="upload" name="file" :action="importUrl" :on-success="onUploadSuccess" :format="['xlsx','xls']"
			:show-upload-list="false" style="display: none;">
			<Button />
		</Upload>

		<Modal title="Title" v-model="modal8" :mask-closable="false" width="380">
			<p slot="header" style="color:#0066FF;text-align:center">
				<Icon type="md-create" />
				<span>搜索</span>
			</p>
			<div style="text-align:center">
				<CheckboxGroup v-model="selectedCondition" class="check_grop">
					<div>
						<Checkbox label="meterId">
							<span>基表编号</span>
						</Checkbox>
						<Input v-model="meterId" placeholder="请输入基表编号" style="width: 200px" />
					</div>
				</CheckboxGroup>
			</div>
			<div slot="footer">
				<Button icon="md-search" type="info" size="large" long @click="searchByCondition">检索</Button>
			</div>
		</Modal>

		<Modal title="Title" v-model="showBindBase" width="500">
			<p slot="header" style="color:#0066FF;text-align:center">
				<span>绑定基表</span>
			</p>
			<div style="text-align: center;">
				<Input v-model="bindBaseNum" placeholder="请输入基表编号" style="width: 200px;" />
				&nbsp;
				<Button type="primary" :loading="submitLoading" @click="submitBindBase">立即绑定</Button>
			</div>
			<div slot="footer">

			</div>
		</Modal>
	</div>
</template>

<script>
	export default {
		name: "meter_box_manage",
		data() {
			let that = this;
			return {
				columns1: [{
						type: "selection",
						width: 50,
						align: "center"
					},
					{
						title: "基表编号",
						width: 200,
						key: "baseNum",
						align: "center"
					},
					{
						title: "mac地址",
						width: 200,
						key: "mac",
						align: "center"
					},
					{
						title: "sim卡号",
						width: 200,
						key: "iccid",
						align: "center"
					},
					{
						title: "域名",
						width: 300,
						key: "domain",
						align: "center"
					},
					{
						title: "端口",
						width: 100,
						key: "port",
						align: "center"
					},
					{
						title: "型号",
						width: 200,
						key: "model",
						align: "center"
					},
					{
						title: "版本",
						width: 200,
						key: "version",
						align: "center"
					},
					{
						title: "规格",
						width: 200,
						key: "specifications",
						align: "center"
					},
					{
						title: "操作",
						fixed: 'right',
						width: 200,
						slot: "deparams",
						align: "center"
					},
				],
				meterId: '',
				importUrl: '/api/meter/admin/box/imports',
				templateUrl: 'http://www.cnzhuocheng.cn/' + encodeURIComponent('智能盒导入模板.xls'),
				selection: [],
				currentRow: null,
				data1: [],
				loading: true,
				modal8: false,
				currentPage: 1,
				totalRows: 0,
				pageSize: 30,
				selectedCondition: [],
				requestBody: {},
				showBindBase: false,
				bindBaseNum: '',
			};
		},
		created() {
			this.getDataList();
		},
		mounted() {

		},
		methods: {
			dateFtt(fmt, date) {
				return global.dateFtt(fmt, new Date(date));
			},
			clickImport() {
				this.$refs.upload.$el.children[0].children[0].dispatchEvent(new MouseEvent('click'));
			},
			onUploadSuccess(response, file, fileList) {
				if (!response.success) {
					this.$Notice.error({
						title: "异常",
						desc: response.msg
					});
					this.getDataList();
					return;
				}

				this.$Notice.success({
					title: "提示",
					desc: "导入" + response.data.count + "条，" +
						'成功' + response.data.successCount +
						'条，失败' + response.data.failureCount +
						'条，忽略' + response.data.skipCount + '条'
				});
				this.getDataList();
			},
			downTemplate() {
				window.location.href = this.templateUrl + "?" + new Date();
			},
			clickBatchDelete() {
				let that = this;
				if (that.selection.length == 0) {
					that.$Notice.info({
						title: "提示",
						desc: "请选择数据"
					});
					return;
				}

				let macArray = [];
				for (let i in that.selection) {
					let mac = that.selection[i].mac;
					macArray.push(mac);
				}
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认批量删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/box/delete",
							type: "post",
							data: {
								mac: macArray.join(',')
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.getDataList();
							},
							error: function() {
								that.$Notice.error({
									title: "异常",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			onSelectionChange(selection) {
				this.selection = selection;
			},
			clickBindBase(row) {
				this.currentRow = row;
				this.bindBaseNum = '';
				this.showBindBase = true;
			},
			submitBindBase() {
				let that = this;
				if (that.bindBaseNum == '') {
					that.$Notice.error({
						title: "提示",
						desc: "请输入基表编号"
					});
					return;
				}
				that.submitLoading = true;
				$.ajax({
					url: "/api/meter/admin/box/bindBase",
					type: "post",
					data: {
						mac: that.currentRow.mac,
						baseNum: that.bindBaseNum
					},
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.$Notice.success({
							title: "提示",
							desc: "绑定成功"
						});
						that.showBindBase = false;
						that.getDataList();
					},
					error: function(textStatus) {
						that.$Notice.error({
							title: "提示",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.submitLoading = false;
					}
				});
			},
			clickUnbindBase(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认解绑？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/box/unbindBase",
							type: "post",
							data: {
								mac: row.mac
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									return;
								}

								that.$Notice.success({
									title: "提示",
									desc: "解绑成功"
								});
								that.getDataList();
							},
							error: function(textStatus) {
								that.$Notice.error({
									title: "提示",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			clickDelete(row) {
				let that = this;
				that.$Modal.confirm({
					title: '提示',
					content: '<p>确认删除？</p>',
					onOk: () => {
						that.loading = true;
						$.ajax({
							url: "/api/meter/admin/box/delete",
							type: "post",
							data: {
								mac: row.mac
							},
							success: function(result) {
								if (!result.success) {
									that.$Notice.error({
										title: "异常",
										desc: result.msg
									});
									that.getDataList();
									return;
								}

								that.getDataList();
							},
							error: function(textStatus) {
								that.$Notice.error({
									title: "提示",
									desc: "网络异常"
								});
							},
							complete: function() {
								that.loading = false;
							}
						});
					},
					onCancel: () => {

					}
				});
			},
			// 修改页面容量
			changePageSize(pageSize) {
				this.pageSize = pageSize;
				this.request();
			},
			changePage(index) {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.currentPage = index;
				this.getDataList();
			},
			// 按条件检索点击事件
			searchByCondition() {
				this.requestBody = {};
				for (var temp in this.selectedCondition) {
					if (this.selectedCondition[temp] == "meterId") {
						if (this.meterId == "") {
							continue;
						}
						this.requestBody["meterId"] = this.meterId;
					}
				}

				this.loading = true;
				this.modal8 = false;
				this.currentPage = 1;
				this.getDataList();
			},
			getDataList() {
				var that = this;
				that.loading = true;
				if (localStorage.getItem("isAdmin") != "true") {
				that.requestBody["companyNum"] = localStorage.getItem("personnelGroverningBodyId");
    			}
				$.ajax({
					url: "/api/meter/admin/box/getPage?currentPage=" +
						that.currentPage +
						"&pageSize=" +
						that.pageSize +
						"&paging=true",
					type: "post",
					data: that.requestBody,
					success: function(result) {
						if (!result.success) {
							that.$Notice.error({
								title: "异常",
								desc: result.msg
							});
							return;
						}

						that.data1 = result.data.list;
						that.totalRows = result.data.totalRows;
						that.selection = [];
					},
					error: function() {
						that.$Notice.error({
							title: "异常",
							desc: "网络异常"
						});
					},
					complete: function() {
						that.loading = false;
					}
				});
			},
			// 显示条件检索页面
			searchByConditionsView() {
				this.modal8 = true;
			}
		}
	};
</script>

<style>
	.ivu-notice-notice {
		width: 500px;
		right: 160px;
	}

	.query_condition {
		border: 1px solid #c0c0c0;
		padding: 2px;
		margin: 2px;
		border-radius: 5%;
	}

	.check_grop div {
		margin-bottom: 1px;
	}
</style>
